import React from 'react';
import { useApp } from '../contexts/AppContext';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../components/ui/tooltip';
import { MessageCircle, Users, Gamepad2 } from 'lucide-react';

const WG_LOGO = "https://static.prod-images.emergentagent.com/jobs/32198471-8102-40f1-a326-847363e8173f/images/3065190e7ba77fed444752a99f45b2f6c5ec03a15f7da25d660302b44036af44.png";

export const ServerRail = () => {
  const { view, switchToServer, switchToFriends, dms } = useApp();
  const { t } = useTranslation();

  const unreadDMs = dms.filter(d => d.unread_count > 0).length;

  return (
    <TooltipProvider delayDuration={200}>
      <div className="w-[72px] h-full bg-[#08090c] flex flex-col items-center py-3 gap-2 overflow-y-auto scrollbar-hide" data-testid="server-rail">
        {/* DM / Friends button */}
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={switchToFriends}
              data-testid="nav-friends"
              className={`relative w-12 h-12 rounded-2xl flex items-center justify-center transition-all duration-200 ${
                view === 'friends' || view === 'dms'
                  ? 'bg-cyan-600 rounded-2xl'
                  : 'bg-[#1a1d23] hover:bg-cyan-600/80 hover:rounded-2xl rounded-[24px]'
              }`}
            >
              <MessageCircle className="h-5 w-5 text-white" />
              {unreadDMs > 0 && (
                <span className="absolute -bottom-0.5 -right-0.5 h-4 min-w-4 px-1 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                  {unreadDMs}
                </span>
              )}
            </button>
          </TooltipTrigger>
          <TooltipContent side="right" className="bg-[#1a1d23] border-white/10 text-white">
            {t('app.directMessages')}
          </TooltipContent>
        </Tooltip>

        {/* Separator */}
        <div className="w-8 h-[2px] bg-white/10 rounded-full my-0.5" />

        {/* World Gaming Server */}
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={switchToServer}
              data-testid="nav-server"
              className={`relative w-12 h-12 flex items-center justify-center transition-all duration-200 overflow-hidden ${
                view === 'server'
                  ? 'rounded-2xl ring-2 ring-cyan-500/50'
                  : 'rounded-[24px] hover:rounded-2xl'
              }`}
            >
              <img src={WG_LOGO} alt="World Gaming" className="w-full h-full object-cover" />
              {/* Active indicator */}
              {view === 'server' && (
                <div className="absolute left-[-4px] top-1/2 -translate-y-1/2 w-1 h-10 bg-white rounded-r-full" />
              )}
            </button>
          </TooltipTrigger>
          <TooltipContent side="right" className="bg-[#1a1d23] border-white/10 text-white">
            World Gaming
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
};
